import { createApiAction } from '@app/packages/api/utils'
import type { ApiCreditCard, ApiCreditCardPostRequest, ApiStripeSetupIntent } from '@app/packages/api/v2/types/entities'

export const getCard = () => createApiAction('getCard', dispatch => dispatch<{ data: ApiCreditCard | null }>({ method: 'GET', endpoint: '/api/v2/card' }))

export const deleteCard = () => createApiAction('deleteCard', dispatch => dispatch<unknown>({ method: 'DELETE', endpoint: '/api/v2/card' }))

export const postCardCloudpayments = (crypto: string, holder_name: string) =>
  createApiAction('postCardCloudpayments', dispatch =>
    dispatch<{ data: ApiCreditCardPostRequest | ApiCreditCard }>({
      method: 'POST',
      endpoint: '/api/v2/card/cloudpayments',
      body: JSON.stringify({ crypto, holder_name }),
    })
  )

export const postCardCloudpayments3ds = (response: { MD: string; PaRes: string }) =>
  createApiAction('postCardCloudpayments3ds', dispatch =>
    dispatch<{ data: ApiCreditCard }>({
      method: 'POST',
      endpoint: '/api/v2/card/cloudpayments/3ds',
      body: JSON.stringify({ transaction_id: response.MD, pa_res: response.PaRes }),
    })
  )

export const postCardStripeSetupIntent = () =>
  createApiAction('postCardStripeSetupIntent', dispatch =>
    dispatch<{ data: ApiStripeSetupIntent }>({ method: 'POST', endpoint: '/api/v2/card/stripe/setup_intent' })
  )
